export default __webpack_public_path__ + "static/media/OGDeity.97fcf1c1.webp";